import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/solid';

const ComparisonTable = () => {
  const features = [
    { name: 'Azure Focus', description: 'Specialised in Azure Cloud' },
    { name: 'Cross-Platform Learning', description: 'Learn on Android/iPhone app or laptop' },
    { name: 'Flexible Pricing', description: 'Choose from our affordable monthly subscriptions' },
    { name: 'Scholarship Program', description: 'Free access for eligible students from developing countries' },
    { name: 'Industry Experts', description: 'Learn from actual Cloud Engineers' },
    { name: 'Hands-on Projects', description: 'Real-world project experience' },
    { name: 'Community Support', description: 'Active learning community' },
    { name: 'Regular Updates', description: 'Content refreshed constantly to stay up-to-date' }
  ];

  return (
    <section className="py-12 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Why Choose Our Bootcamp?
          </h2>
          <p className="text-lg text-gray-600">
            See how we compare to traditional cloud bootcamps
          </p>
        </motion.div>

        <div className="relative bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="grid grid-cols-3">
            {/* Headers */}
            <div className="p-4 border-b border-gray-100">
              <h3 className="text-base font-semibold text-gray-900">Features</h3>
            </div>
            <div className="p-4 border-b border-gray-100 text-center bg-blue-50">
              <h3 className="text-base font-semibold text-[#0EA5E9]">Kloud Skool</h3>
            </div>
            <div className="p-4 border-b border-gray-100 text-center">
              <h3 className="text-base font-semibold text-gray-500">Other Bootcamps</h3>
            </div>

            {/* Features */}
            {features.map((feature, index) => (
              <React.Fragment key={feature.name}>
                <div className={`p-3 ${index !== features.length - 1 ? 'border-b border-gray-100' : ''}`}>
                  <p className="font-medium text-sm text-gray-900">{feature.name}</p>
                  <p className="text-xs text-gray-500 mt-0.5">{feature.description}</p>
                </div>
                <div className={`p-3 flex items-center justify-center bg-blue-50 ${index !== features.length - 1 ? 'border-b border-gray-100' : ''}`}>
                  <CheckIcon className="w-5 h-5 text-[#0EA5E9]" />
                </div>
                <div className={`p-3 flex items-center justify-center ${index !== features.length - 1 ? 'border-b border-gray-100' : ''}`}>
                  {['Azure Focus', 'Cross-Platform Learning', 'Lifetime Access', 'Flexible Pricing', 'Scholarship Program', 'Industry Experts', 'Hands-on Projects', 'Community Support', 'Regular Updates'].includes(feature.name) ? (
                    <XMarkIcon className="w-5 h-5 text-red-400" />
                  ) : (
                    <CheckIcon className="w-5 h-5 text-gray-400" />
                  )}
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-lg font-semibold text-gray-900 mb-4">
            Join Kloud Skool today and experience the difference:
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            <div className="bg-white rounded-lg p-3 shadow-md">
              <p className="text-sm text-[#0EA5E9] font-medium">Azure Focused</p>
              <p className="text-xs text-gray-600 mt-0.5">Expert-led training</p>
            </div>
            <div className="bg-white rounded-lg p-3 shadow-md">
              <p className="text-sm text-[#0EA5E9] font-medium">Flexible Plans</p>
              <p className="text-xs text-gray-600 mt-0.5">Pay your way</p>
            </div>
            <div className="bg-white rounded-lg p-3 shadow-md">
              <p className="text-sm text-[#0EA5E9] font-medium">Social Impact</p>
              <p className="text-xs text-gray-600 mt-0.5">Scholarship program</p>
            </div>
            <div className="bg-white rounded-lg p-3 shadow-md">
              <p className="text-sm text-[#0EA5E9] font-medium">Industry Ready</p>
              <p className="text-xs text-gray-600 mt-0.5">Real-world skills</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable; 